module.exports = __webpack_public_path__ + "img/dingwei.fce19cde.png";